import { AddOnSelection } from '@Config/ticket-form-types'
import { AddOnTypes } from '@Config/types'
import {
  ExtraDrawsAddOnRuleConfig,
  MiniGameAddOnRuleConfig,
  MultiplierAddOnRuleConfig,
} from '@interaction-gaming/game-data-service-browser-client'
import * as Form from '@radix-ui/react-form'
import { ReactSVG } from 'react-svg'

type AddonRuleConfig =
  | MultiplierAddOnRuleConfig
  | ExtraDrawsAddOnRuleConfig
  | MiniGameAddOnRuleConfig

type AddonRuleConfigWithHostValue = AddonRuleConfig & {
  iconUrl: string | undefined
}

export type AddOnCheckboxProps = {
  type: AddOnTypes.EXTRA_DRAWS | AddOnTypes.MULTIPLIER | AddOnTypes.MINI_GAME
  disabled: boolean
  selection: AddonRuleConfigWithHostValue
  selected: boolean
  onSelect: (addOn: AddOnSelection, selected: boolean) => void
}

const CLASS_NAME = 'gby-k2g-ticket-form'

export const BooleanAddOnCheckbox = (props: AddOnCheckboxProps) => {
  const selection = {
    type: props.type,
    name: props.selection.name,
    numberSelections: [],
  }

  const keyDownInputHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      props.onSelect(selection, Boolean(!e.currentTarget.checked))
    }
  }

  return (
    <Form.Field
      key={props.selection.name}
      className={`${CLASS_NAME}__form-addon-field`}
      name={props.selection.name}>
      <div className={`${CLASS_NAME}__form-addon-field-inner-container`}>
        <Form.Control asChild>
          <input
            aria-labelledby={props.selection.name}
            className={`${CLASS_NAME}__addon--input`}
            onClick={(e) => props.onSelect(selection, Boolean(e.currentTarget.checked))}
            onKeyDown={keyDownInputHandler}
            type="checkbox"
            checked={props.selected}
            disabled={props.disabled}
          />
        </Form.Control>

        <Form.Label
          id={props.selection.name}
          className={`${CLASS_NAME}__form-addon-label ${props.disabled === true ? `${CLASS_NAME}__form-addon-label-disabled` : ``}`}>
          {props.selection.iconUrl ? (
            <ReactSVG
              role="button"
              className={`${CLASS_NAME}__form-addon-field-inner-container__logo ${props.disabled === true ? `${CLASS_NAME}__form-addon-field-inner-container__logo-disabled` : ``}`}
              src={props.selection.iconUrl}
            />
          ) : null}
          {props.selection.name}
        </Form.Label>
      </div>
    </Form.Field>
  )
}
